import { Button, Card, Carousel, Col, Row, Grid, Skeleton } from "antd";

import re_100 from "../../assets/re100_logo.jpg";
import Certificate_2 from "../../assets/Certificate_2.png";
import Verified_Carbon_1 from "../../assets/Verified_Carbon_1.png";
import Verified_Carbon_2 from "../../assets/Verified_Carbon_2.png";

import flexibleFormat from "../../functions/flexibleFormat";

const { useBreakpoint } = Grid;

export const RECCard = (props) => {
  const { netEmission, emissionSummary, abatementSummary, year, loading } =
    props;
  const { emissionScope2List, siteProfileList, abatementList } = props;
  const { gridEmissionFactor = 0.758 } = props;
  const screens = useBreakpoint();

  let scope2Emission = 0;
  emissionSummary
    .filter((element) => element.InventoryYear === year)
    .forEach((element) => {
      scope2Emission += element.Category2CO2e;
    });

  const abatement = abatementSummary.find((element) => element.Year === year);
  const scope2Abatement = abatement ? abatement["2"] : 0;

  const carbonCredits = (
    0.05 * netEmission > 1 ? 0.05 * netEmission : 1
  ).toFixed(0);
  let renewablePercentNum = (scope2Abatement / scope2Emission) * 100;
  if (renewablePercentNum > 100) {
    renewablePercentNum = 100;
  } else if (renewablePercentNum < 0) {
    renewablePercentNum = 0;
  }
  const renewablePercent = renewablePercentNum.toFixed(0);

  let recNumber = 0;

  const recNumberStr = recNumber.toFixed(0);

  // Separate button so that the behavior can be coded here without going to layout code
  const VERButton = () => {
    return (
      <Button
        disabled={true}
        block
        style={{
          borderRadius: "5px",
          border: "1px solid rgba(35,33,118,0)",
        }}
        type="primary"
      >
        <h3 style={{ margin: "0px" }}>
          Buy VER<sub>s</sub>
        </h3>
      </Button>
    );
  };

  const VCUButton = () => {
    return (
      <Button
        disabled={true}
        block
        style={{
          borderRadius: "5px",
          border: "1px solid rgba(35,33,118,0)",
        }}
        type="primary"
      >
        <h3 style={{ margin: "0px" }}>
          Buy VCU<sub>s</sub>
        </h3>
      </Button>
    );
  };

  return (
    <Card
      size="small"
      title={
        <h5 style={{ margin: "0px", fontSize: "17.6px" }}>
          Environmental Attributes
        </h5>
      }
      style={{
        width: "100%",
        height: screens.xl ? "100%" : "auto",
      }}
    >
      <div style={{ width: "100%", height: "100%" }}>
        <Row
          style={{
            width: "100%",
            height: screens.xl ? "45%" : "auto",
            display: screens.xl ? "flex" : "block",
            justifyContent: screens.xl ? "space-evenly" : "normal",
          }}
        >
          <Row style={{ height: "10%", width: "100%" }}>
            <Col span={24} style={{ padding: "5px 0px" }}>
              <h3 style={{ margin: "0px" }}>Carbon Credits</h3>
            </Col>
          </Row>
          <Row style={{ height: "10%", width: "100%" }}>
            <Col
              span={24}
              style={{
                paddingBottom: "5px",
              }}
            >
              <h3 style={{ margin: "0px", fontSize: "14px" }}>
                Further offset the your net emission by 5% with
              </h3>
            </Col>
          </Row>
          {loading && (
            <div style={{ width: "100%", padding: "8px" }}>
              <Skeleton active />
            </div>
          )}
          <Row
            style={{
              height: "20%",
              width: "100%",
              display: loading ? "none" : "flex",
            }}
          >
            <Col
              xs={24}
              sm={24}
              md={12}
              style={{
                height: "100%",
                width: "100%",
              }}
            >
              <div
                style={{
                  height: "50%",
                  width: "100%",
                  textAlign: "center",
                  padding: screens.md ? "10px 30px 0px 0px" : "16px",
                }}
              >
                <img
                  alt={"Verified Carbon Standard"}
                  style={{ width: "100%", height: "auto", maxWidth: "240px" }}
                  src={Verified_Carbon_1}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  padding: screens.md ? "10px 30px 0px 0px" : "8px",
                  display: screens.xs
                    ? "block"
                    : screens.sm && !screens.md
                    ? "block"
                    : "none",
                }}
              >
                <VCUButton />
              </div>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              style={{ padding: "5px 18px", width: "100%" }}
            >
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  padding: screens.md ? "16px" : "32px",
                }}
              >
                <img
                  alt={"Gold Standard"}
                  style={{ width: "100%", height: "auto", maxWidth: "240px" }}
                  src={Verified_Carbon_2}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  padding: screens.md ? "10px 30px 0px 0px" : "8px",
                  display: screens.xs
                    ? "block"
                    : screens.sm && !screens.md
                    ? "block"
                    : "none",
                }}
              >
                <VERButton />
              </div>
            </Col>
          </Row>
          {/* A row to display button in larger screen */}
          <Row
            style={{
              display: screens.md ? "flex" : "none",
              width: "100%",
            }}
          >
            <Col span={12} style={{ padding: "8px" }}>
              <VCUButton />
            </Col>
            <Col span={12} style={{ padding: "8px" }}>
              <VERButton />
            </Col>
          </Row>
          <Row style={{ height: "10%", width: "100%" }}>
            <Col span={24} style={{ padding: "5px 0px" }}>
              <h3 style={{ margin: "0px" }}>Renewable Energy Certificate</h3>
            </Col>
          </Row>
          <Row style={{ height: "10%", width: "100%" }}>
            <Col
              span={24}
              style={{
                paddingBottom: "5px",
              }}
            >
              <h3 style={{ margin: "0px", fontSize: "14px" }}>
                Further reduce your Scope 2 emissions with
              </h3>
            </Col>
          </Row>
          <Row
            style={{
              display: "flex",
              width: "100%",
            }}
          >
            <Col span={24} style={{ padding: "8px" }}>
              <div
                style={{ width: "100%", padding: "8px", textAlign: "center" }}
              >
                <img
                  alt="RE 100"
                  src={re_100}
                  style={{
                    margin: "auto", // Center the image
                    height: "auto",
                    width: "100%",
                    maxWidth: "180px",
                  }}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  padding: "0px 9px",
                  textAlign: "center",
                }}
              >
                <Button
                  disabled={true}
                  block
                  style={{
                    borderRadius: "5px",
                    border: "1px solid rgba(35,33,118,0)",
                    width: "100%",
                    maxWidth: "180px",
                  }}
                  type="primary"
                >
                  <h3 style={{ margin: "0px" }}>Buy RECS</h3>
                </Button>
              </div>
              <div
                style={{
                  width: "100%",
                  padding: "4px",
                }}
              >
                <h4
                  style={{
                    margin: "0px",
                    marginTop: "8px",
                    fontSize: "14px",
                    lineHeight: "1",
                    textAlign: "center",
                  }}
                >
                  Commit to 100% Renewable Electricity
                </h4>
              </div>
            </Col>
          </Row>
        </Row>
      </div>
    </Card>
  );
};
